import styled from 'styled-components'

const OlStyled = styled.ol`
  padding-left: 18px;
`

export default OlStyled
